module.exports = __webpack_public_path__ + "24b7df64cdf95aa4e09db9d71061d5df.fbx";